import * as React from 'react';

const ProductBlockGridDivider = ({ children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-grid-divider"
    }, children);
};

export { ProductBlockGridDivider };
//# sourceMappingURL=ProductBlockGridDivider.js.map
